import axios from "axios";
import {
  fetchFilesSuccess,
  fetchFilesFailure,
  fetchStarredFilesSuccess,
  fetchDeletedFilesSuccess,
  fetchSharedFilesSuccess,
} from "../../Redux/Files/FileActions";

const HOME_API = "https://decloud-backend.ashusharmaprod.repl.co/get/defiles";
const STARRED_API =
  "https://decloud-backend.ashusharmaprod.repl.co/get/starred";
const SHARED_API = "https://decloud-backend.ashusharmaprod.repl.co/get/shared";
const BIN_API = "https://decloud-backend.ashusharmaprod.repl.co/get/bin";

export const fetchHomeFiles = (userId) => {
  return (dispatch) => {
    axios
      .post(HOME_API, {
        user: userId,
      })
      .then((res) => {
        const filesData = res.data.files;
        dispatch(fetchFilesSuccess(filesData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(fetchFilesFailure(errorMsg));
      });
  };
};

export const fetchStarredFiles = (userId) => {
  return (dispatch) => {
    axios
      .post(STARRED_API, {
        user: userId,
      })
      .then((res) => {
        const filesData = res.data.files;
        dispatch(fetchStarredFilesSuccess(filesData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(fetchFilesFailure(errorMsg));
      });
  };
};

export const fetchSharedFiles = (userEmail) => {
  return (dispatch) => {
    axios
      .post(SHARED_API, {
        user: userEmail,
      })
      .then((res) => {
        const filesData = res.data.files;
        dispatch(fetchSharedFilesSuccess(filesData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(fetchFilesFailure(errorMsg));
      });
  };
};

export const fetchDeletedFiles = (userId) => {
  return (dispatch) => {
    axios
      .post(BIN_API, {
        user: userId,
      })
      .then((res) => {
        const filesData = res.data.files;
        dispatch(fetchDeletedFilesSuccess(filesData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(fetchFilesFailure(errorMsg));
      });
  };
};
